var ImageThumbController = function(JobService, QAService, $scope) {
  var _self = this;

  _self.tempLibraryViewCode = null;
  _self.errorMessage = null;
  _self.qaData = QAService.get();
  _self.libraryViewCodeModified = false;
  _self.originalLibraryViewCode = _self.assetJob
    ? _self.assetJob.libraryViewCode
    : null;
  _self.lvcOptions = QAService.getValidLibraryViewCodes();

  if (_self.model && !_self.model.cropType) {
    var deliverable =
      _self.model.relatedAssets && _self.model.relatedAssets.Deliverable;
    _self.model.cropType = deliverable ? deliverable.cropType : null;
  }

  _self.expectedCropTypes = _self.job ? _self.job.expectedCropTypes : null;

  _self.displayDeliverableImage = function(isCropTypeDeliverable) {
    if (!_self.model) {
      return;
    }
    var deliverableAsset = isCropTypeDeliverable
      ? _self.model
      : _self.model.relatedAssets && _self.model.relatedAssets.Deliverable;
    if (!deliverableAsset) {
      return;
    }
    _self.url = JobService.getImageByType(deliverableAsset, 'all');
  };

  $scope.$watch(
    function() {
      return _self.model;
    },
    function() {
      if (!_self.model) {
        return;
      }
      var isCropTypeDeliverable = _self.model.type === 'Deliverable';
      if (
        !isCropTypeDeliverable &&
        !(
          _self.model.relatedAssets && _self.model.relatedAssets.Deliverable
        )
      ) {
        return;
      }
      _self.displayDeliverableImage(isCropTypeDeliverable);
    },
    true
  );

  $scope.$watch(
    function() {
      return _self.assetJob && _self.assetJob.libraryViewCode;
    },
    function() {
      if (angular.isFunction(_self.validateLibraryViewCodes)) {
        _self.validateLibraryViewCodes();
      }
    }
  );
};

module.exports = ImageThumbController;
